import {Component, Inject, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {Equipement} from 'app/models/equipement.model';
import {Piece} from '../../../../models/piece.model';
import {User} from '../../../../models/user.model';
import {EquipementService} from '../../../../services/equipement.service';
import {UserService} from '../../../../services/user.service';
import {PieceEquipement} from '../../../../models/pieceEquipement.model';
import {DossierInterventionService} from '../../../../services/dossier_intervention.service';
import {Croquis} from '../../../../models/croquis.model';
import {Etage} from '../../../../models/etage.model';

@Component({
    selector: 'app-modal-dossier-croquis',
    templateUrl: './modal-dossier-croquis.component.html'
})
export class ModalDossierCroquis implements OnInit {
    @Input() idDossierIntervention: number;
    @Input() croquis: Croquis = new Croquis();

    success: boolean = false;
    error: boolean = false;
    equipements: Array<Equipement> = [];
    etages: Array<Etage> = [];
    croquisForm: FormGroup;


    constructor(
        private dossierInterventionService: DossierInterventionService,
        private userService: UserService,
        public dialogRef: MatDialogRef<ModalDossierCroquis>,
    ) {
    }

    ngOnInit(): void {
        this.croquisForm = new FormGroup({
            id: new FormControl(this.croquis.id),
            nom: new FormControl(this.croquis.nom, [Validators.required]),
            etage_id: new FormControl(this.croquis.etage_id, [Validators.required]),
        });

        this.fetchAll();
    }

    fetchAll(): void {
        this.fetchEtages();
    }

    fetchEtages(): void {
        this.dossierInterventionService.getEtagesForDossierIntervention(this.idDossierIntervention).subscribe((etages) => {
            this.etages = etages;
        });
    }

    onFormSubmit(): void {
        this.error = false;
        this.success = false;
        this.croquisForm.markAllAsTouched();

        if (this.croquisForm.valid) {
          const croquis = new Croquis(this.croquisForm.value);

          if (croquis.id === null) {
              this.dossierInterventionService.storeCroquisForDossierIntervention(this.idDossierIntervention, croquis).subscribe(
                  (response) => {
                      this.success = true;
                      this.dialogRef.close(response);
                  }, (error) => { this.error = true; }
              );
          } else {
              this.dossierInterventionService.updateCroquisForDossierIntervention(this.idDossierIntervention, croquis).subscribe(
                  (response) => {
                      this.success = true;
                      this.dialogRef.close(response);
                  }, (error) => { this.error = true; }
              );
          }

        }
    }
}
